import { CanActivateFn } from '@angular/router';
import { UserRole } from '../user-context/user-context.model';
import { deniedUrl } from './denied-url';
import { withUserContext } from './with-user-context';

/**
 * Allows activation only for the roles listed in route `data.requiredRoles`
 * (FDD §4). Waits until the user context has resolved, then fails closed to
 * /unauthorized (SECURITY-08). A role without access during an org-switch reload goes
 * to the landing page instead (see deniedUrl).
 */
export const roleGuard: CanActivateFn = (route) => {
  const requiredRoles = (route.data['requiredRoles'] as UserRole[] | undefined) ?? [];
  const denied = deniedUrl();

  return withUserContext(({ role }) =>
    requiredRoles.length === 0 || requiredRoles.includes(role) ? true : denied,
  );
};
